module.exports = __webpack_public_path__ + "img/ren-1.118cc23e.svg";